import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import RequestListItem from 'components/RequestListItem';
import CollabInviteAvailableListItem from 'components/CollabInviteAvailableListItem';
import CollabListItem from 'components/CollabListItem';
import { CollabProps } from 'stores/collab_store';
import { FHRequestType } from 'stores/fhrequest_store';
import { CollabInviteProps } from 'stores/collab_invite_store';
import { CollaboratorsProps } from 'stores/collaborators_store';

import useCollabs from 'hooks/useCollabs';
import useCurrentIdentity from 'hooks/useCurrentIdentity';


export type WorkItemType = FHRequestType | CollabInviteProps | CollaboratorsProps | CollabProps;


const CollabWorkItem = observer(({ item }: { item: WorkItemType }) => {
    const { getCollab, fetchCollab } = useCollabs();
    const currentIdentity = useCurrentIdentity();
    useEffect(() => {
        if(!currentIdentity)
            return;

        if (item.cls == 'collaborators') {
            const collab = getCollab((item as CollaboratorsProps).collab);
            if (!collab)
                fetchCollab(currentIdentity?.uuid, (item as CollaboratorsProps).collab);
        }
    }, [currentIdentity?.uuid, item]);

    function _collab(item: WorkItemType): CollabProps | null {
        if (item.cls == 'collab')
            return item as CollabProps;
        else if (item.cls == 'collaborators')
            return getCollab((item as CollaboratorsProps).collab);
        else
            return null;
    };

    const collab = _collab(item);

    return <CollabListItem collab={collab} />

});

export default function WorkListItem({ item }: { item: WorkItemType }) {


    if (item.cls == 'request')
        return <RequestListItem
                   request={item as FHRequestType}
        />
    else if (item.cls == 'collab' || item.cls == 'collaborators') {
        return <CollabWorkItem
                   item={item}
        />

    }
    else
        return <CollabInviteAvailableListItem
                   invite={item as CollabInviteProps} />

}
